exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_object-gops.js
// module id = 630
// module chunks = 27